import IconBolt from '@/shared/icons/NewDesign/IconBolt'
import IconPhone from '@/shared/icons/NewDesign/IconPhone'
import IconShieldPerson from '@/shared/icons/NewDesign/IconShieldPerson'
import { PulseTabIconSlot } from '../styled-components'

const ICON_BY_TYPE = {
  energy: IconBolt,
  telecom: IconPhone,
  insurance: IconShieldPerson,
}

interface PulseContractTabIconProps {
  type: string
  active: boolean
}

const PulseContractTabIcon = ({ type, active }: PulseContractTabIconProps) => {
  const Icon = ICON_BY_TYPE[type as keyof typeof ICON_BY_TYPE]

  if (!Icon) return null

  return (
    <PulseTabIconSlot aria-hidden='true' $active={active}>
      <Icon size={16} color='currentColor' />
    </PulseTabIconSlot>
  )
}

export default PulseContractTabIcon
